// @ts-nocheck
import React, { useState } from 'react';

import { Button, Checkbox, Form, Input, Alert, Switch } from 'antd';
import Ball from "./Ball"

const BilliardsScoreboard = () => {

    const [padding, setPadding] = useState(6);
    const [nome_rodada, setNomeRodada] = useState("");
    const [nome_jog1, setNomeJ1] = useState("");
    const [nome_jog2, setNomeJ2] = useState("");
    const [rod_jog1, setRodJ1] = useState(0);
    const [rod_jog2, setRodJ2] = useState(0);

    const [bolas_j1, setBolasJ1] = useState<any[]>([]);
    const [bolas_j2, setBolasJ2] = useState<any[]>([]);

    const setJog1Impar = (isImpar) => {

        const impar = [
            {
                "num": 3,
                "visib": true
            },
            {
                "num": 5,
                "visib": true
            },
            {
                "num": 7,
                "visib": true
            },
            {
                "num": 9,
                "visib": true
            },
            {
                "num": 11,
                "visib": true
            },
            {
                "num": 13,
                "visib": true
            },
            {
                "num": 15,
                "visib": true
            }
        ];

        const par = [
            {
                "num": 2,
                "visib": true
            },
            {
                "num": 4,
                "visib": true
            },
            {
                "num": 6,
                "visib": true
            },
            {
                "num": 8,
                "visib": true
            },
            {
                "num": 10,
                "visib": true
            },
            {
                "num": 12,
                "visib": true
            },
            {
                "num": 14,
                "visib": true
            }
        ]

        if (isImpar) {
            setBolasJ1(impar);
            setBolasJ2(par)
            console.log('impar')
        } else {
            setBolasJ1(par);
            setBolasJ2(impar)
            console.log('par')
        }
    };

    const resetBolas = () => {
        setBolasJ1([]);
        setBolasJ2([])
    }

    const iniTerceiro = () => {

        setNomeRodada('TERCEIRO LUGAR')
        setNomeJ1('EDSON');
        setNomeJ2('JOÃO PAULO');
        setRodJ1(0);
        setRodJ2(0);
        resetBolas()
    };

    const iniFinal = () => {

        setNomeRodada('GRANDE FINAL')
        setNomeJ1('DAVID');
        setNomeJ2('PAULO');
        setRodJ1(0);
        setRodJ2(0);
        resetBolas()
    };

    const onChange = (jog, checked) => {

        if(jog == 1){
            setBolasJ1((bolas_j1) =>
                bolas_j1.map((ball) =>
                    ball.num === checked.num ? { ...ball, visib: !checked.visib } : ball
                )
            );
        }else{
            setBolasJ2((bolas_j2) =>
                bolas_j2.map((ball) =>
                    ball.num === checked.num ? { ...ball, visib: !checked.visib } : ball
                )
            );
        }

    };

    return (
        <div style={{ width: 600, backgroundColor: 'white' }}>
            <table style={{ width: 600, borderCollapse: 'collapse', border: '1px solid #000', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
                <tr>
                    <th colSpan="5" style={{ backgroundColor: '#363636', color: 'white', fontSize: 18, padding: padding }}>{nome_rodada}</th>
                </tr>
                <tr>
                    <td style={{ width: 220, fontSize: 22, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: padding }}>{nome_jog1}</td>
                    <td style={{ fontSize: 22, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold' }}>{rod_jog1}</td>
                    <td style={{ fontSize: 22, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold' }}>X</td>
                    <td style={{ fontSize: 22, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold' }}>{rod_jog2}</td>
                    <td style={{ width: 220, fontSize: 22, border: '1px solid #000', fontWeight: 'bold', padding: padding }}>{nome_jog2}</td>
                </tr>
                <tr>
                    <td style={{ width: 220, fontSize: 18, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: padding }}>
                        {bolas_j1.map((b, index) => {
                            if (b.visib == true) {
                                return (<Ball key={index} ball={b.num} visible={b.visib}/>)
                            }
                        })}
                        {bolas_j1.length > 0 && !bolas_j1.find(x => x.visib === true) && <Ball ball={1} visible={true} />}
                    </td>
                    <td colSpan="3"></td>
                    <td style={{ width: 220, fontSize: 18, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: padding }}>
                        {bolas_j2.map((b, index) => {
                            if (b.visib == true) {
                                return (<Ball key={index} ball={b.num} visible={b.visib}/>)
                            }
                        })}
                        {bolas_j2.length > 0 && !bolas_j2.find(x => x.visib === true) && <Ball ball={1} visible={true}/>}
                    </td>
                </tr>
            </table>
            <br />
            <br />
            <br />
            <br />
            <Button style={{ margin:5 }} size="large" type="primary" onClick={iniTerceiro}>Ini terceiro</Button>
            <Button style={{ margin:5 }}  size="large" type="primary" onClick={iniFinal}>Ini final</Button>
            <br />
            <Button style={{ margin:5 }}  size="large" type="primary" onClick={() => { setJog1Impar(true) }}>J1 impar</Button>
            <Button  style={{ margin:5 }} size="large" type="primary" onClick={() => { setJog1Impar(false) }}>J1 par</Button>
            <br />
            <Button  style={{ margin:5 }} size="large" type="primary" onClick={resetBolas}>Reset bolas</Button>
            <Form.Item
                label="Nome rodada"
                onChange={(e) => setNomeRodada(e.target.value)}
            >
                <Input defaultValue={nome_rodada} />
            </Form.Item>
            <Form.Item
                label="Nome jogador 1"
                onChange={(e) => setNomeJ1(e.target.value)}
            >
                <Input defaultValue={nome_jog1} />
            </Form.Item>
            <Form.Item
                label="Rodadas jogador 1"
                onChange={(e) => setRodJ1(e.target.value)}
            >
                <Input type='number' min={0} defaultValue={0} />
            </Form.Item>
            <Form.Item
                label="Nome jogador 2"
                onChange={(e) => setNomeJ2(e.target.value)}
            >
                <Input defaultValue={nome_jog1} />
            </Form.Item>
            <Form.Item
                label="Rodadas jogador 2"
                onChange={(e) => setRodJ2(e.target.value)}
            >
                <Input type='number' min={0} defaultValue={0} />
            </Form.Item>
            <table>
                <tr>
                    <td style={{ width: 220, fontSize: 22, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: padding }}>{nome_jog1}</td>
                    <td style={{ width: 220, fontSize: 22, border: '1px solid #000', fontWeight: 'bold', padding: padding }}>{nome_jog2}</td>
                </tr>
                <tr>
                    <td style={{ width: 220, fontSize: 18, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: padding }}>
                        {bolas_j1.map((b, index) => {
                            return (<><Switch key={index} onChange={() => { onChange(1, b) }} defaultValue={b.visib} /> {b.num}</>)
                        })}
                    </td>
                    <td style={{ width: 220, fontSize: 18, border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: padding }}>
                        {bolas_j2.map((b, index) => {
                            return (<><Switch key={index} onChange={() => { onChange(2, b) }} defaultValue={b.visib} /> {b.num}</>)
                        })}
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default BilliardsScoreboard;